import { ICubeResponse } from "@spawn/backend-adapter-cube";
import { consumer } from "@spawn/core";
import { INetworkState } from "@spawn/networking";
import { CacheKeys, CacheStorage } from "../../utils/cacheStorage";
import { INrgCubeGameResult } from "../types/cube";
import { FGInitActionCube } from "./fgInitActionCube";

@consumer
export class FGPseudoInitActionCube extends FGInitActionCube {
	public execute(): Promise<INetworkState> {
		const response = CacheStorage.get<ICubeResponse<INrgCubeGameResult>>(CacheKeys.FirstFGResumeResponse);
		if (!response) {
			throw new Error("No cached response found");
		}

		return Promise.resolve(this.parse(response, this.adapter));
	}
}
